<div class="dialog-layout">
    <div class="dialog-main">
        <div
            class="d-flex align-items-center"
            [style.background-color]="statusColor ? '#' + statusColor : null"
            mat-dialog-title>
            <div class="spacer title" title="{{ data?.planning?.id }}">
                <i class="fa-regular fa {{ entitytypes[mainEntityType?.key]?.icon }}"></i>

                {{ mainEntityType?.name }}

                @if (Features.PlanningSaveSave | hasFeature) {
                    {{ !data.copy && data.planning?.id ? 'aanpassen' : 'toevoegen' }}
                }

                <span class="mat-text-disabled">{{ codaltModusService.enabled() ? data?.planning?.id : '' }}</span>

                @if (existingPlannings.length > 1 || fieldFormData?.form.controls.planning.controls.repetition.value) {
                    <i class="fa-regular fa-arrows-repeat" title="Herhaling"></i>
                }

                @if (inPast) {
                    &nbsp;<span class="mat-text-disabled">(in het verleden)</span>
                }
            </div>
            <div>
                <button [disabled]="saving" (click)="close()" mat-icon-button tabindex="-1">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <mat-dialog-content class="dialog-content">
            @if (fieldFormData) {
                <div class="main-column">
                    <div
                        class="fields-holder"
                        [class.allow-user-edit]="fieldFormData.orginal | userCanEditPlanning: mainEntityType"
                        [class.notallowed]="isExistingPlanning === false"
                        [class.readonly]="existingPlannings.length > 1 || externalChanged">
                        <app-fields-template [template]="activeTemplate" [formData]="fieldFormData" />
                    </div>

                    <div class="mt-1">
                        <app-trackline-planning-has [fieldFormData]="fieldFormData" [entityTypes]="entityTypesTable" />
                    </div>

                    <div class="mt-3">
                        <app-trackline-employee-planning [formData]="fieldFormData" />
                    </div>

                    <div class="mt-3">
                        <app-trackline-planning-materials [fieldFormData]="fieldFormData" />
                    </div>

                    <div class="mt-3">
                        <app-trackline-planning-files [fieldFormData]="fieldFormData" />
                    </div>
                </div>
            }
        </mat-dialog-content>

        <mat-dialog-actions class="d-flex justify-content-between" *ngIf="fieldFormData">
            <div class="d-flex">
                @if (!externalChanged && fieldFormData?.orginal?.id && (Features.PlanningSaveSave | hasFeature)) {
                    @if (!mobile) {
                        @if (!fieldFormData.form?.disabled) {
                            <button
                                [disabled]="saving || externalChanged || data.planning.deleted_at"
                                (click)="delete()"
                                color="warn"
                                color="warn"
                                mat-button>
                                Verwijderen
                            </button>
                        }

                        <button
                            [disabled]="saving || externalChanged || data.planning.deleted_at"
                            (click)="copy()"
                            mat-raised-button>
                            Kopiëren
                        </button>
                    }
                }
                @if (environment.enableDayreport && (Features.DayreportsSave | hasFeature)) {
                    <button [disabled]="saving" (click)="dayReport()" mat-raised-button>
                        {{ fieldFormData.form.dirty ? 'Opslaan & ' : '' }}Dagrapport
                    </button>
                }
                @if (fieldFormData.orginal) {
                    <button [disabled]="saving" (click)="orderForm()" mat-raised-button>
                        {{ fieldFormData.form.dirty ? 'Opslaan & ' : '' }}Opdrachtformulier
                    </button>
                }

                @if ((Features.PlanningDetailHistory | hasFeature) && fieldFormData?.orginal?.id) {
                    <button [disabled]="saving || loadingHistory" (click)="openHistory()" mat-button>
                        {{ loadingHistory ? 'Historie wordt geladen...' : 'Historie' }}
                    </button>
                }

                @if (data.infoMessage) {
                    <div class="flex-fill info-message">
                        {{ data.infoMessage }}
                    </div>
                }

                @if (data.planning?.deleted_at) {
                    <div class="flex-fill fixed-date-message">
                        Deze planning is verwijderd op {{ data.planning.deleted_at | date: 'EEEE d MMMM yyyy H:m' }}.
                    </div>
                }

                @if (externalChanged && !deleted && !saving) {
                    <div class="flex-fill fixed-date-message">
                        Deze planning is vanaf een ander apparaat aangepast. Open de planning opnieuw om wijzigingen aan
                        te brengen.
                    </div>
                } @else if (externalChanged && deleted && !saving) {
                    <div class="flex-fill fixed-date-message">
                        Deze planning is verwijderd vanaf een ander apparaat.
                    </div>
                }

                @if (fixedDate) {
                    <div class="flex-fill fixed-date-message">
                        De planning is vastgezet tot {{ fixedDate | date: 'EEEE d MMMM yyyy' }}.
                    </div>
                }

                @if (fieldFormData.mainPhe?.disabledByRoles && !externalChanged) {
                    <div class="flex-fill fixed-date-message">
                        Dit item kan alleen door een planner en
                        {{ data.planning?.projectmanager_user?.name }}
                        worden aangepast.
                    </div>
                }
            </div>

            @if (!mobile) {
                <div class="d-flex">
                    <button class="me-2" [disabled]="saving" (click)="close()" color="accent" mat-raised-button>
                        Annuleren
                    </button>

                    @if (
                        !externalChanged &&
                        fieldFormData?.form &&
                        (Features.PlanningSaveSave | hasFeature) &&
                        !fieldFormData.form?.disabled
                    ) {
                        <button
                            [disabled]="
                                data.dirty === true
                                    ? false
                                    : saving ||
                                      externalChanged ||
                                      !fieldFormData.form.dirty ||
                                      data.planning?.deleted_at
                            "
                            (click)="save()"
                            mat-raised-button
                            color="primary">
                            {{ saving ? 'Aan het opslaan...' : 'Opslaan' }}
                        </button>
                    }
                </div>
            }
        </mat-dialog-actions>

        @if (dragOver) {
            <div
                class="drop-overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center z-2">
                <i class="fa-regular fa-file-arrow-up fa-3x mb-2"></i>
                <span>Bestand hier loslaten om te uploaden</span>
            </div>
        }

        @if (saving) {
            <div
                class="loading position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white z-1"
                style="--bs-bg-opacity: 0.7">
                <mat-spinner />
            </div>
        }
    </div>

    @if (!mobile && fieldFormData?.orginal?.afas_project_id) {
        <div class="related-column">
            <app-related-plannings
                [afasProjectId]="fieldFormData.orginal.afas_project_id"
                [currentPlanningId]="fieldFormData.orginal.id"
                [referenceDate]="fieldFormData.orginal.mainPlanning.begindate"
                [materialsById]="materialsById"
                (open)="openRelatedPlanning($event)" />
        </div>
    }
</div>
